<template>
  <div class="pa-3 height-full">
    <v-card class="pa-3" variant="outlined">
      <AssetLifecycleCostsChart />
    </v-card>
    <v-card class="pa-3 mt-4" variant="outlined">
      <PM02PM03Chart />
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { useFilterStore } from "@/store/filter";
import AssetLifecycleCostsChart from "@/components/metrics/AssetLifecycleCostsChart.vue";
import PM02PM03Chart from "@/components/metrics/PM02PM03Chart.vue";

const filters = useFilterStore();
filters.hide();
</script>
